module.exports = __webpack_public_path__ + "static/pinkbib-669d07a54dae07b268d8cf3ad2d7fa45.png";